import { Person } from '@fs/zion-person'
import { type SummaryPerson } from '@fs/zion-tree-types'
import React, { type ReactNode, type ComponentProps } from 'react'
import PersonCreatedDate from './PersonCreatedDate'
import PersonTextAlignmentDecorator from '../common/PersonTextAlignmentDecorator'

type PersonTextAlignmentDecoratorMdProps = {
  children: ReactNode
}

function PersonTextAlignmentDecoratorMd({ children }: PersonTextAlignmentDecoratorMdProps): JSX.Element {
  return <PersonTextAlignmentDecorator avatarSize={40}>{children}</PersonTextAlignmentDecorator>
}

type Props = Omit<ComponentProps<typeof Person>, 'personObj' | 'isMobileOrientation'> & {
  personObj: Partial<SummaryPerson> | undefined
  isMobileOrientation: boolean
}

export default function PersonAndDateAdded({ personObj, isMobileOrientation, ...props }: Props): JSX.Element {
  const PersonCreatedDateWrapper = isMobileOrientation ? PersonTextAlignmentDecorator : PersonTextAlignmentDecoratorMd
  return (
    <div>
      <Person personObj={personObj} {...props} />
      {personObj?.creationDateMs && (
        <PersonCreatedDateWrapper>
          <PersonCreatedDate size="xs" secondary creationDateMs={personObj.creationDateMs} />
        </PersonCreatedDateWrapper>
      )}
    </div>
  )
}
